import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { InstrukcijaPlacanja } from './instrukcija-placanja';

@Component({
  selector: 'yt-instrukcija-placanja-inline-update',
  templateUrl: './instrukcija-placanja-inline-update.component.html'
})
export class InstrukcijaPlacanjaInlineUpdateComponent extends BaseInlineUpdateComponent<InstrukcijaPlacanja> {

  constructor(protected inlineContainerService: InlineContainerService<InstrukcijaPlacanja>){
      super(inlineContainerService);
    }

   
}
